import React, { useState } from 'react';
import logo from './../../Let_sSync.webp'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar light expand="md">
        <NavbarBrand target={'_blank'} href={'https://www.lets-sync.com/'}><img width='80' height='40' src={logo} /></NavbarBrand>
        {/*<NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem>
              <NavLink href="/show-all/" target={"_blank"}>Show All Videos</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/show-play-list/" >Play List Videos</NavLink>
            </NavItem>
          </Nav>
        </Collapse>*/}
      </Navbar>
    </div>
  );
}

export default Header;